import { useState } from 'react'

export default function MovieImage({ src, className, alt, onLoad }) {
    const [error, setError] = useState(false)
    const defaultImage = '/images/backgrounds/defaultImage.jpg'
    return (
        <img
            src={error ? defaultImage : src}
            onLoad={onLoad}
            onError={() => setError(true)}
            alt={alt}
            className={className}
        />
    )
}
